export default (targetInput: HTMLInputElement) => {
  const fakeInput = document.createElement('input');

  fakeInput.setAttribute('type', 'text');
  fakeInput.style.position = 'absolute';
  fakeInput.style.opacity = '0';
  fakeInput.style.height = '0';
  fakeInput.style.fontSize = '16px';

  document.body.prepend(fakeInput);
  fakeInput.focus();

  setTimeout(() => {
    targetInput.focus();
    fakeInput.remove();
  }, 750);
};
